import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a6e2ae2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"max-width":"200px"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*", -1))
const _hoisted_3 = {
  key: 0,
  class: "namespace"
}
const _hoisted_4 = {
  key: 1,
  class: "namespace"
}
const _hoisted_5 = {
  key: 2,
  class: "namespace"
}
const _hoisted_6 = ["onClick"]

import { TirPmDropdown, TirPmDropdownSizeEnum, TirPmIconView, TirPmSvg } from "tir-components";
import { onBeforeMount } from "vue";
import { ref, computed, onMounted, watch } from "vue";
import { TaskParameterTypeEnum } from "../task-parameter";
import { PropType } from "vue";
import {
  ChevronDownIcon,
  ChevronUpIcon,
  FolderIcon,
  ListBulletIcon,
} from "tir-style-system/icons/outline";
import { GroupModel, NamespaceModel, QueueTasksModel } from "../sidebar/models";
import { TaskLocation } from ".";


export default /*#__PURE__*/_defineComponent({
  __name: 'task-location-dropdown',
  props: {
  modelValue: { type: Object as PropType<QueueTasksModel> },
  /**Тип проекта */
  type: { type: Number as PropType<TaskParameterTypeEnum> },
  /**
   * дерево данныхё
   */
  items: { type: Array as PropType<NamespaceModel[]>, default: [] },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;

// Импорты из Vue 3 Composition API

const visibleIdx = ref<Array<string>>([]);
/**API сервис */

/**Параметры */

/**События */


/**Список проектов */
const localItems = ref<(NamespaceModel | GroupModel | QueueTasksModel)[]>([]);

/**Перед рендером */
onBeforeMount(() => getItems());
onMounted(async () => {
  //  await getItems();
});
watch(
  () => props.items,
  async (value) => {
    if (value.length > 0) await getItems();
  },
);
const dropdownTaskLocation = ref();
/**Получить список проектов */
const getItems = async (value: string = "") => {
  localItems.value = props.items.map((item) => item);
};
const breadcrumbs = ref([]);
function onChangeSub(item: NamespaceModel | QueueTasksModel | GroupModel, isShow: boolean) {
  if (item instanceof QueueTasksModel) {
    emit("update:modelValue", item);
    dropdownTaskLocation.value.close();
    breadcrumbs.value = getBreadcrumbs(item.Id);
    return;
  }

  if (isShow) {
    insertAfter(
      localItems.value.findIndex((i) => i.Id == item.Id),
      item.Groups as any,
    );
    insertAfter(
      localItems.value.findIndex((i) => i.Id == item.Id),
      item.QueueTasks as any,
    );
    return;
  }

  if (item instanceof NamespaceModel) {
    localItems.value = localItems.value.filter(
      (i) =>
        !item.Groups.some((group) => group.Id == (i.Id as any)) &&
        !item.QueueTasks.some((task) => task.Id == i.Id) &&
        !(item.Id == (i as any)?.NamespaceId),
    );
    return;
  }

  localItems.value = localItems.value.filter(
    (i) =>
      !item?.Groups.some((group) => group.Id == (i.Id as any)) &&
      !item?.QueueTasks.some((task) => task.Id == i.Id),
  );
}
/**Выбор проекта */
const selectProject = (project: NamespaceModel) => {
  if (project instanceof QueueTasksModel) {
    emit("update:modelValue", project);
    dropdownTaskLocation.value.close();
    console.log(project);
  }
};
/**Вставить элементы в массив после определенного элемента */
const insertAfter = (index: number, newItems: NamespaceModel[]) => {
  localItems.value.splice(index + 1, 0, ...newItems);
};

/** */
function getBreadcrumbs(taskId) {
  const breadcrumbs = [];
  let currentTask = localItems.value.find((task) => task.Id === taskId);
  let namespace = localItems.value.find(
    (task) => task.Id === (currentTask as QueueTasksModel).NamespaceId,
  );
  while (currentTask) {
    breadcrumbs.unshift(currentTask);
    const tmp = localItems.value.find((task) => task.Id === (currentTask as any)?.ParentGroupId);
    currentTask = tmp;
  }

  breadcrumbs.unshift(namespace);

  return breadcrumbs;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmDropdown), {
    ref_key: "dropdownTaskLocation",
    ref: dropdownTaskLocation,
    class: "choose-project-dropdown",
    width: "16rem",
    popoverWidth: "21rem",
    options: localItems.value,
    showOnHover: true,
    size: _unref(TirPmDropdownSizeEnum).Light,
    "selected-option": __props.modelValue,
    isSearchLocal: false,
    isHiddenSearch: true,
    isExcludeSelected: false,
    onUpdateSearch: getItems,
    optionListScrollHeight: "24rem"
  }, {
    target: _withCtx((slot) => [
      _createElementVNode("div", {
        class: _normalizeClass(["choose-project-dropdown_target", { sel: __props.modelValue }])
      }, [
        (!__props.modelValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createTextVNode(" Расположение тикета "),
              _hoisted_2
            ]))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(breadcrumbs.value, (el, idx) => {
              return (_openBlock(), _createElementBlock("div", { key: idx }, [
                (el instanceof _unref(NamespaceModel))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_unref(TirPmSvg), {
                        url: el.IconUrl,
                        class: "namespace-item__namespace-icon",
                        style: {"font-size":"1rem"},
                        color: el.Color
                      }, null, 8, ["url", "color"]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["namespace-title_hidden", { title_visible: true }])
                      }, _toDisplayString(el.Name), 1),
                      _createTextVNode(" / ")
                    ]))
                  : _createCommentVNode("", true),
                (el instanceof _unref(GroupModel))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_unref(FolderIcon), { class: "namespace-item__namespace-icon" }),
                      _createElementVNode("div", {
                        class: _normalizeClass(["namespace-title_hidden", { title_visible: true }])
                      }, _toDisplayString(el.Name), 1),
                      _createTextVNode(" / ")
                    ]))
                  : _createCommentVNode("", true),
                (el instanceof _unref(QueueTasksModel))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_unref(ListBulletIcon), { class: "namespace-item__namespace-icon" }),
                      _createElementVNode("div", {
                        class: _normalizeClass(["namespace-title_hidden", { title_visible: true }])
                      }, _toDisplayString(el.Name), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
        (!__props.modelValue)
          ? (_openBlock(), _createBlock(_unref(ChevronDownIcon), {
              key: 2,
              class: _normalizeClass(["choose-project-dropdown_target_arrow", { open: slot.isOpened }])
            }, null, 8, ["class"]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    optionList: _withCtx((slot) => [
      _createElementVNode("div", {
        class: _normalizeClass(["choose-project-dropdown_option", { selected: __props.modelValue?.Id == slot.option.Id.toString() }]),
        onClick: _withModifiers(($event: any) => (selectProject(slot.option)), ["stop"])
      }, [
        _createVNode(_unref(TaskLocation), {
          item: slot.option,
          onOnChange: onChangeSub
        }, null, 8, ["item"])
      ], 10, _hoisted_6)
    ]),
    _: 1
  }, 8, ["options", "size", "selected-option"]))
}
}

})